import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './CustomModal.css'

const CustomModal = ({ show, handleClose, handleConfirm }) => {
  const [confirmClicked, setConfirmClicked] = useState(false);


  return (
    <Modal className='custom-modal' centered   show={show} onHide={handleClose}>
      <Modal.Body>
        <p className='title'>Are you sure, You want to delete this product from Draft ?</p>
        <p className='light-title'>(This action can't be undo)</p>

        <div className='action-buttons'>
        <Button variant="primary" className='yes-button flex-center' onClick={handleConfirm}>
          Yes
        </Button>
        <Button className='no-button' variant="secondary flex-center" onClick={handleClose}>
          No
        </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
